import React, { useEffect, useState, useRef } from "react";
import withRouter from "components/Common/withRouter";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  FormFeedback,
  Input,
  Form, // Form'u reactstrap'ten import edin
  FormGroup, // FormGroup'u da ekleyin
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from 'axios';
import { isEmpty } from "lodash";
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  document.title = "Bildirim | Bee Education Admin PANELI";
  const dispatch = useDispatch();

  const [getCategory, setCategory] = useState([]);
  const [getCategoryID, setCategoryID] = useState(null);
  // 'single' (tekil) veya 'all' (tümü) gönderim türünü tutmak için state
  const [notificationScope, setNotificationScope] = useState('single');

  // Kullanıcıları API'den çeken fonksiyon
  const _getAuthData = async () => {
    try {
      const res = await axios.get(`https://beeducationadmin.stechomeyazilim.info:8093/getUsersBee/select/`);
      setCategory(res.data);
    } catch (error) {
      console.error("Kullanıcılar alınamadı:", error);
    }
  };

  useEffect(() => {
    _getAuthData();
  }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      desc: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Lütfen bildirim başlığını giriniz."),
      desc: Yup.string().required("Lütfen bildirim açıklamasını giriniz."),
    }),
    onSubmit: async (values, { resetForm }) => {
      // Gönderim butonuna basıldığında çalışacak mantık
      if (notificationScope === 'single' && !getCategoryID) {
        alert('Lütfen bildirim göndermek için bir kullanıcı seçin!');
        return;
      }

      // API'ye gönderilecek temel payload
      let payload = {
        title: values.title,
        body: values.desc, // Genellikle push servisleri 'body' alanını kullanır
        icerikTuru: "kullanici"
      };

      // Gönderim türüne göre payload'ı düzenle
      if (notificationScope === 'single') {
        payload.USERID = getCategoryID;
      } else {
        // Herkese göndermek için 'topic' anahtarı kullanılıyor.
        // PHP tarafı bu anahtarı kontrol edecek.
        payload.topic = 'all';
      }

      try {
        // Bu endpoint'i kendi push notification gönderim endpoint'iniz ile değiştirin
        const pushEndpoint = 'https://trimentoradmin.stechomeyazilim.info:4436/pushnotificationKupon1/send';
        await axios.post(pushEndpoint, payload);
        
        // Sadece tekil kullanıcıya gönderim yapıldıysa, bildirimi veritabanına kaydet
        if (notificationScope === 'single') {
            const notificationDbPayload = {
                IsActive: true,
                Created_DateTime: new Date().toISOString(),
                Notification_Desc: values.desc,
                Notification_Title: values.title,
                Users_ID: getCategoryID,
                Notification_Type_ID: 2, // Örnek tip ID'si
                Notification_Seen: false
            };
            // Bu endpoint'i veritabanına kayıt yapan endpoint'iniz ile değiştirin
            const dbEndpoint = 'https://trimentoradmin.stechomeyazilim.info:4436/addNotificationKupon/send';
            await axios.post(dbEndpoint, notificationDbPayload);
        }

        alert('Bildirim başarıyla gönderildi!');
        resetForm();
        setCategoryID(null);

      } catch (error) {
        console.error("Bildirim gönderilirken hata oluştu: ", error);
        alert("Bildirim gönderilirken bir hata oluştu.");
      }
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Bildirim Gönder" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* Formik'in handleSubmit'ini kullanmak için Form etiketini ekleyin */}
                  <Form onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}>
                    <Row>
                      <Col xs={12}>
                        {/* Gönderim Kapsamı Seçimi */}
                        <FormGroup tag="fieldset" className="mb-3">
                          <legend className="col-form-label">Gönderim Kapsamı</legend>
                          <Row>
                            <Col md={6}>
                                <FormGroup check>
        <Label for="scope_single" check>
                                        <Input
                                            type="radio"
                                            name="notificationScope"
                                            value="single"
                                                      id="scope_single" // ID eklendi

                                         checked={notificationScope === 'single'}
          onChange={() => setNotificationScope('single')}
                                        />{' '}
                                        Tek Kullanıcıya Gönder
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup check>
                                           <Label for="scope_all" check>

                                        <Input
                                            type="radio"
                                                      id="scope_all" // ID eklendi

                                            name="notificationScope"
                                            value="all"
                                            checked={notificationScope === 'all'}
                                            onChange={() => setNotificationScope('all')}
                                        />{' '}
                                        Tüm Kullanıcılara Gönder
                                    </Label>
                                </FormGroup>
                            </Col>
                          </Row>
                        </FormGroup>

                        {/* Kullanıcı Seçim Alanı (sadece 'single' seçiliyse görünür) */}
                        {notificationScope === 'single' && (
                          <div className="mb-3">
                            <Label className="form-label">Kullanıcı Seçiniz</Label>
                            <Input
                              name="kullanici"
                              type="select"
                              className="form-select"
                              onChange={(e) => setCategoryID(e.target.value)}
                              value={getCategoryID || ""}
                            >
                              <option value="">Lütfen Seçim Yapınız</option>
                              {getCategory.map((item) => (
                                <option value={item.ID} key={item.ID}>{item.ID} - {item.Users_NameSurname}</option>
                              ))}
                            </Input>
                          </div>
                        )}

                        {/* Bildirim Başlık */}
                        <div className="mb-3">
                          <Label className="form-label">Bildirim Başlık</Label>
                          <Input
                            name="title"
                            type="text"
                            placeholder="Bildirim Başlık Giriniz"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.title}
                            invalid={validation.touched.title && !!validation.errors.title}
                          />
                          {validation.touched.title && validation.errors.title ? (
                            <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                          ) : null}
                        </div>

                        {/* Bildirim Açıklama */}
                        <div className="mb-3">
                          <Label className="form-label">Bildirim Açıklama</Label>
                          <Input
                            name="desc"
                            type="textarea"
                            rows="4"
                            placeholder="Bildirim Açıklama Giriniz"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.desc}
                            invalid={validation.touched.desc && !!validation.errors.desc}
                          />
                          {validation.touched.desc && validation.errors.desc ? (
                            <FormFeedback type="invalid">{validation.errors.desc}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end">
                          <button type="submit" className="btn btn-success save-user">
                            BİLDİRİM GÖNDER
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);